export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEGQjVwYy1IYQyhSwDqTg4A6y8BAOsxAAGBAgIBgQYCAYEKAgGBDgIBgRICAYEWAgGBGgIBgR5oAOpP", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/B5pc-V.bcmap
// module id = 616
// module chunks = 502